export default class HandleDA {
  static handleTypeHasCustomizableLogo(type) {
    const typelc = type && type.toLowerCase ? type.toLowerCase() : type;

    return typelc === 'hvs003' || typelc === 'hhs014';
  }
}
